export const MENU_ITEM_NAME = "Menu Item Name";

export const RESTAURANT_ADD_FORM_NAME = "Add Restaurant";

export const RESTAURANT_EDIT_FORM_NAME = "Edit Restaurant Details";

export const PAYOUTS_PAYMENTS_NAME = "Payments";

export const NAV_LIST_RESTAURANT_VIEW = [
  {
    id: 1,
    item: "Restaurant Details",
  },
  {
    id: 2,
    item: "Wallet",
  },
  {
    id: 3,
    item: "Bank Details",
  },
];

/**
 Menu Item Types
 **/
export const CUSTOM_MENU_ITEM_TYPE = "CustomMenu";
export const SET_MENU_ITEM_TYPE = "SetMenu";
export const SINGLE_ITEM_TYPE = "Single";
export const SINGLE_MENU_ITEM_TYPE = "MenuItem";

/**
 Order Status
 **/
export const PENDING_ORDER_STATUS = "Pending";
export const ACCEPTED_BY_CART_ORDER_STATUS = "AcceptedByCart";
export const APPROVED_BY_RESTAURANT_ORDER_STATUS = "ApprovedByRestaurant";
export const COLLECTING_ORDER_STATUS = "Collecting";
export const PREPARING_ORDER_STATUS = "Preparing";
export const READY_AT_KITCHEN_ORDER_STATUS = "ReadyAtKitchen";
export const ARRIVED_ORDER_STATUS = "ArrivedAtCart";
export const COMPLETED_ORDER_STATUS = "Completed";
export const CANSEL_ORDER_STATUS = "Cansel";
export const ISSUED_BY_KITCHEN_ORDER_STATUS = "IssuedByKitchen";

/**
Refund Order Status
**/
export const REFUND_ORDER_STATUS = [
  { value: "All", label: "All" },
  { value: "Completed", label: "Completed" },
  { value: "Pending", label: "Pending" },
  { value: "Rejected", label: "Rejected" },
];

export const RESTAURANT_STATUS = [
  { value: "ALL", label: "All" },
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
];

export const CART_STATUS = [
  { value: "ALL", label: "All" },
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "DELETED", label: "Deleted" },
];

export const CART_PERSON_STATUS = [
  { value: "ALL", label: "All" },
  { value: "PENDING", label: "Pending" },
  { value: "APPROVED", label: "Approved" },
  { value: "REJECTED", label: "Rejected" },
  { value: "DELETED", label: "Deleted" },
];

export const CART_TYPES = [
  { value: "all", label: "All" },
  { value: "fixed", label: "Fixed" },
  { value: "delivery", label: "Delivery" },
  { value: "moving", label: "Moving" },
];

export const NAV_LIST_CART_VIEW = [
  {
    id: 1,
    item: "Cart Details",
  },
  {
    id: 2,
    item: "Restaurants",
  },
  {
    id: 3,
    item: "Cart Person",
  },
  {
    id: 4,
    item: "Inventory",
  },
  {
    id: 5,
    item: "Live Location",
  },
  {
    id: 6,
    item: "Sales",
  }
];

export const NAV_LIST_CART_PERSON_VIEW = [
  {
    id: 1,
    item: "Cart Person Details",
  },
  {
    id: 2,
    item: "Wallet",
  },
  {
    id: 3,
    item: "Bank Details",
  },
];

export const NAV_LIST_WALLET_HISTORY = [
  {
    id: 1,
    item: "Sales",
  },
  {
    id: 2,
    item: "Payment",
  },
];

export const NAV_LIST_COMMISSION = [
  {
    id: 1,
    item: "Overview",
  },
  {
    id: 2,
    item: "Inventory",
  },
  {
    id: 3,
    item: "Transactions",
  },
  {
    id: 4,
    item: "Payouts",
  },
];

export const REASONS_FOR_GO_OFFLINE = [
  "Closing Time",
  "Stock not available",
  "Cart under maintenance",
  "Other",
];

export const CART_TYPE: CartTypeOption[] = [
  { value: { isFixedLocation: false, type: "delivery" }, label: "Delivery" },
  { value: { isFixedLocation: false, type: "moving" }, label: "Moving" },
  { value: { isFixedLocation: true, type: "fixed" }, label: "Fixed" },
];

export const PAYMENT_BREAKDOWN_SORT_TYPE = [
  { value: "All", label: "ALL" },
  { value: "Pending", label: "PENDING" },
  { value: "Completed", label: "COMPLETED" },
  { value: "Cancelled", label: "CANCELLED" },
];

export const NAV_LIST_ROLES_PERMISSIONS = [
  {
    id: 1,
    item: "Roles",
  },
  {
    id: 2,
    item: "Feature Groups",
  },
  {
    id: 3,
    item: "Features",
  },
  {
    id: 4,
    item: "Permissions Matrix",
  },
];

// Admin status constants
export const ADMIN_STATUS = [
  { value: "All", label: "All" },
  { value: "Approved", label: "Approved" },
  { value: "Deleted", label: "Deleted" },
];

export const GOOGLE_MAPS_LIBRARIES: (
  | "places"
  | "drawing"
  | "geometry"
  | "marker"
)[] = ["places", "drawing", "geometry", "marker"];

export const GOOGLE_MAPS_API_KEY = "AIzaSyD_zEfLidcypXTaAVeiQVX5PHlrcj6xEpM";

export interface CartTypeOption {
  value: {
    isFixedLocation: boolean;
    type: string;
  };
  label: string;
}

export type ChannelOption = { value: string; label: string };

// Define supported channels options
export const SUPPORTED_CHANNELS_OPTIONS = [
  { value: "WhatsApp", label: "Whatsapp" },
  { value: "WalkIn", label: "Walk In" },
  { value: "WebPickup", label: "Web Pickup" },
  { value: "OnRoute", label: "On Route" },
  { value: "WebDelivery", label: "Web Delivery" },
   { value: "PickMeUber", label: "PickMe/ Uber" },
];

